import createInformesSectionPage from "./SectionPageFactory";

const InformesContabilidadPage = createInformesSectionPage(
  "Contabilidad",
  "Revisá balances, estados contables y registros auxiliares consolidados."
);

export default InformesContabilidadPage;
